import fr from 'facet-rest';
import Checkbox from 'Components/UI/Checkbox';

export const NotificationPreferenceOverride = fr.metaOverride()
  .overrideAll({
    _component: () => Checkbox,
    _customProps: {
      color: 'primary',
    },
  });
